export const ACTIVITY_LIST_FILTERS = [
  {
    "name": "Stage",
    "columnName": "stageName",
    "enabled": true,
    "displayOrder": 10,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Log Type",
    "columnName": "type",
    "enabled": true,
    "displayOrder": 30,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Log Sub Type",
    "columnName": "subType",
    "enabled": true,
    "displayOrder": 50,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Created By",
    "columnName": "createdByUserName",
    "enabled": true,
    "displayOrder": 60,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Created Date",
    "columnName": "createdDate",
    "enabled": true,
    "displayOrder": 70,
    "fieldDataType": "DateTime",
    "formControlType": "DatePicker",
    "isDateWithTime": true,
    "operators": [
      "On",
      "NotOn",
      "Before",
      "OnOrBefore",
      "After",
      "OnOrAfter",
      "Between",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Updated By",
    "columnName": "updatedByUserName",
    "enabled": true,
    "displayOrder": 80,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Updated Date",
    "columnName": "updatedDate",
    "enabled": true,
    "displayOrder": 90,
    "fieldDataType": "DateTime",
    "formControlType": "DatePicker",
    "isDateWithTime": true,
    "operators": [
      "On",
      "NotOn",
      "Before",
      "OnOrBefore",
      "After",
      "OnOrAfter",
      "Between",
      "HasValue",
      "NoValue"
    ]
  }
];

export const ACTIVITY_LIST_FILTERS_ACCOUNTS = [
  {
    "name": "Account Category",
    "columnName": "stageName",
    "enabled": true,
    "displayOrder": 10,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Log Type",
    "columnName": "type",
    "enabled": true,
    "displayOrder": 30,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Log Sub Type",
    "columnName": "subType",
    "enabled": true,
    "displayOrder": 50,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Created By",
    "columnName": "createdByUserName",
    "enabled": true,
    "displayOrder": 60,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Created Date",
    "columnName": "createdDate",
    "enabled": true,
    "displayOrder": 70,
    "fieldDataType": "DateTime",
    "formControlType": "DatePicker",
    "isDateWithTime": true,
    "operators": [
      "On",
      "NotOn",
      "Before",
      "OnOrBefore",
      "After",
      "OnOrAfter",
      "Between",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Updated By",
    "columnName": "updatedByUserName",
    "enabled": true,
    "displayOrder": 80,
    "fieldDataType": "Enum",
    "valueSelection": "name",
    "formControlType": "DropDownList",
    "isDateWithTime": false,
    "operators": [
      "IsEqualTo",
      "IsNotEqualTo",
      "HasValue",
      "NoValue"
    ]
  },
  {
    "name": "Updated Date",
    "columnName": "updatedDate",
    "enabled": true,
    "displayOrder": 90,
    "fieldDataType": "DateTime",
    "formControlType": "DatePicker",
    "isDateWithTime": true,
    "operators": [
      "On",
      "NotOn",
      "Before",
      "OnOrBefore",
      "After",
      "OnOrAfter",
      "Between",
      "HasValue",
      "NoValue"
    ]
  }
];
